import apiClient from '../apiClient';
import { POST_IMAGE_RESTAURANT_PROFILE_URL } from '../apiUrl';

const postUploadImageRestaurantProfileApi = (Id, data) => {
  return apiClient.post(POST_IMAGE_RESTAURANT_PROFILE_URL(Id), data);
};

export default postUploadImageRestaurantProfileApi;
